import AgendaView from './AgendaView';
export default AgendaView;
